export const Heading = () => {
  return (
    <div
      css={`
        padding: 45px 20px 16px;
        line-height: 42px;
        font-size: 36px;
        font-family: "Pretendard", sans-serif;
        letter-spacing: -0.432px;

        @media (min-width: 960px) {
          padding: 0 0 12px 0;
          line-height: 60px;
          font-size: 48px;
          font-family: "Pretendard", sans-serif;
          letter-spacing: -0.576px;
        }
      `}
    >
      Ready to get started?
    </div>
  );
};
